import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { AppConstants } from '../../app.constants';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable()
export class AuthService {
    userName: string;
    constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

    postLoginDetails(email: string, password: string): Observable<any> {
        let body = {
            "email": email,
            "password": password,
            "remember": true
        }

        console.log('Call API');
        // return this.http.post(`${AppConstants.API_ENDPOINT1 + 'auth/login/'}`, body)
        return this.http.post(`${AppConstants.API_ENDPOINT1 + 'auth/login/'}`, body).pipe(catchError((error) => this.errorHandlerService.handleError(error))
        );
    }
}
